<template>
    <div class="xc-page authority">
        <div class="xc-page-main">
            <!-- 面包屑 -->
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/system/authority-setting'">系统设置</router-link>
                <a>角色管理</a>
                <a>菜单管理</a>
            </div>
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form" name="authority">
                            <div class="xc-form-inline">
                                <xc-form-item label="当前角色：">
                                    <input type="text" name="role" :value="roleName" class="xc-input xc-input-disabled" disabled/>
                                </xc-form-item>
                            </div>
                        </form>
                        <div class="tab">
                            <div class="tab-item" @click="tabSwitch(0)" :class="{'active':active==0}">菜单权限</div>
                            <div class="tab-item" @click="tabSwitch(1)" :class="{'active':active==1}">终端组权限</div>
                        </div>
                        <div class="xc-card">
                            <div class="xc-card-content" style="padding: 20px 0">
                                <div class="menu authority" v-show="nav==0">
                                   <!-- <template v-if="roles.length">
                                        <xc-tree
                                            :data.sync="roles"
                                            label="label"
                                            expand
                                            show-checkbox
                                            multiple
                                            linked
                                            indeterminate
                                            @init="initMenu"
                                            @checked="selectMenu"
                                        >
                                        </xc-tree>
                                    </template>-->
                                    <!-- 结构 -->
                                    <ul id="groupRule"></ul>
                                </div>
                                <div class="deviceGroup authority" v-show="nav==1">
                                    <template v-if="deviceGroups.length">
                                        <xc-tree
                                            :data.sync="deviceGroups"
                                            label="name"
                                            :expand="0"
                                            show-checkbox
                                            multiple
                                            linked
                                            :type="1"
                                            @init="initGroup"
                                            @checked="selectGroup">
                                        </xc-tree>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="xc-page-footer">
            <div class="xc-btn-group">
                <button type="button" class="xc-btn xc-btn-default" @click="close">取消</button>
                <button type="button" class="xc-btn xc-btn-primary" @click="submitModel">确定</button>
            </div>
        </div>
    </div>
</template>

<script>
    import authorityImport from '@/libs/authority';
    import role from "@/api/role"
    // 获取树形控件数据
    function getTreeData(){
        var checked = $("#groupRule").find(".checked")
        var len = $("#groupRule").find(".checked").length;
        if (checked.length <= 0) {
            console.log("请勾选选项")
        }
        var i = 0,
            arr = [],
            name = [];
        $(checked).each(function () {
            arr[i] = $(this).attr("id");
            name[i] = $(this).parents('.btn-toggle').find('span[class="label-text"]').html();
            i++;
        });
        var ids = arr.join(",");
        var names = name.join(",");
        return {
            idsdata: ids,
            namedata: names
        };
    }
    export default {
        name: "AuthoritySetting",
        data(){
            return{
                roleId:"",
                roleName:"",
                status:-1,
                roles:[],   //菜单权限
                moduleIds:"",
                deviceGroups:[],    //终端组
                deviceGroupIds:"",
                nav:0,
                active:0
            }
        },
        async created(){
            //   加载一下JS
            await authorityImport();
            this.roleId=this.$route.query.roleId;
            this.roleName=this.$route.query.roleName;
            this.status=this.$route.query.status;
            var obj={
                roleId:this.roleId
            };
            //请求菜单权限
            role.listRoleModule(obj).then(v=>{
                this.roles=this.detailData(v.data);

                // 调用groupRule方法
                this.$nextTick(function () {
                    $("#groupRule").groupRule({ data: this.roles });
                })
                // this.roles=v.data;
            })
        //    请求终端组
            role.roletree(obj).then(v=>{
                this.handleData(v.data);
                this.deviceGroups=v.data;
            })
        },
        methods:{
            //切换导航
            tabSwitch(type){
                this.nav=type;
                this.active=type;
            },
        //    关闭
            close(){
                this.$router.go(-1);
            },
        //    确认
            submitModel(){
                var result=getTreeData();
                this.moduleIds=result.idsdata;
                var options={
                    deviceGroupIds:this.deviceGroupIds,
                    moduleIds:this.moduleIds,
                    roleId:this.roleId,
                    roleName:this.roleName,
                    status:this.status,
                };
                role.update(options).then(v=>{
                    this.$message.success("操作成功");
                    this.close();
                })
            },
            //遍历选中的终端组,返回新数组
            getChecked(data,arr){
                if(data.length){
                    for(let x of data){
                        if(x.checked){
                            //已选
                            arr.push(x.id)
                        }else if(x.indeterminate=="indeterminate"){
                        //    半选
                            this.getChecked(x.children,arr);
                        }else {
                        //    未选
                        }
                    }
                }
                return arr;
            },
            //初始化菜单
            initMenu(data){
                if(data.checked.length){
                    var arr=[];
                    data.checked.forEach(function (item) {
                        arr.push(item.moduleId)
                    });
                    this.moduleIds=arr.join(",")
                }
            },
            //初始化分组
            initGroup(data){
                var arr0=this.getChecked(this.deviceGroups,[]);
                this.deviceGroupIds=arr0.join(",");
            },
            selectMenu(data){
                if(data.checked.length){
                    var arr=[];
                    data.checked.forEach(function (item) {
                        arr.push(item.moduleId)
                    });
                    this.moduleIds=arr.join(",")
                }else {
                    this.moduleIds="";
                }
            },
            selectGroup(data){
                var arr0=this.getChecked(this.deviceGroups,[]);
                this.deviceGroupIds=arr0.join(",");
            },
            //判断该节点的孩子中是否有未选中,若有返回true
            noChecked:function(data){
                if(data.children.length){
                    for(let x of data.children){
                        if(x.checked==true){
                            var result = this.noChecked(x);
                            if(result){
                                return result;
                            }
                        }else {
                            return true;
                        }
                    }
                }else {
                    return false;
                }
            },
            //处理数据
            detailData: function (data) {
                var s_true = "s_true";
                /*var len = data.length;

                for (var i = 0; i < len; i++) {
                    var childs1 = data[i].children;
                    if (childs1.length > 0) {

                        for (var j = 0; j < childs1.length; j++) {
                            var childs2 = childs1[j].children;
                            var len2 = childs2.length;
                            if (len2 > 0) {
                                var sum2 = 0;
                                for (var k = 0; k < len2; k++) {
                                    if (childs2[k].checked == true) {
                                        sum2++
                                    }
                                }
                                if (sum2 === len2) {
                                    childs1[j].checked = true;
                                } else if (sum2 == 0) {
                                    childs1[j].checked = false;
                                } else {
                                    childs1[j].checked = "s_true";
                                }
                                sum2 = 0;
                            }
                        }

                        var len1 = childs1.length;
                        var sum1 = 0;
                        var sum3 = 0;
                        for (var m = 0; m < len1; m++) {
                            if (childs1[m].checked == true) {
                                sum1++
                            } else if (childs1[m].checked == s_true) {
                                sum3++;
                            }
                        }
                        if (sum1 === len1) {
                            data[i].checked = true;
                        } else if (sum1 == 0 && sum3 == 0) {
                            data[i].checked = false;
                        } else {
                            data[i].checked = s_true;
                        }
                        sum1 = 0;
                        sum3 = 0;
                        childs1 = '';
                    }
                }
                return data*/
                if(data.length>0){
                    for(let x of data){
                        if(x.checked){
                            var result=this.noChecked(x);
                            if(result){
                                x.checked=s_true;
                            }
                            this.detailData(x.children)
                        }
                    }
                }
                return data;
            },
        //    处理终端组初始数据
            handleData(data,isChecked){
                if(data.length){
                    for(let x of data){
                        if(isChecked){
                            x.checked=true;
                            this.handleData(x.children,true)
                        }else {
                            if(x.checked){
                                this.handleData(x.children,true)
                            }else {
                                this.handleData(x.children)
                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style  lang="scss">
    @import "../xc-ui/scss/variable.scss";
    .authority{
        .tab{
            display: inline-flex;
            border: 1px solid #cfd5e0;
            border-radius: 6px;
            .tab-item{
                width: 140px;
                height: 40px;
                border-right: 1px solid #cfd5e0;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                &:last-of-type{
                    border-right: 0px;
                }
                &.active{
                    background: $xc-bg;
                    color: #ffffff;
                    border-color: $xc-bg;
                }
            }
        }
        #groupRule{
            .authitem.auth1 span{
                color: #6e7a90 !important;
                background-color: #f3f6fb;
                font-size: 12px;
                height: 41px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .btn-toggle{
                font-size: 14px;
                height: 41px;
                display: flex;
                align-items: center;
                color: #6e7a90 !important;
            }
        }
    }
</style>
